import { components } from '@api/play-account/generated';
import { useMediaQuery } from '@providers/MediaQueryProvider';

import { cx } from '@libs/classnames';
import { pluralize } from '@libs/i18n';
import { CapsuleButton } from '@ui/components/CapsuleButton';
import { Card } from '@ui/components/Card';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';
import { ArrowSlimIcon } from '@ui/icons/ArrowSlimIcon';

import { ClubDto } from '@features/shared/api/typings';
import { PlayerClubs } from '@features/user/ui/PlayerClubs/PlayerClubs';
import { PlayerTournaments } from '@features/user/ui/PlayerTournaments/PlayerTournaments';

import styles from './PlayerClubsAndTournamentsPreview.module.css';

const TOURNAMENTS_PLURAL = {
  one: '{number} турнир',
  few: '{number} турнира',
  many: '{number} турниров',
  zero: '{number} турниров',
};

type Props = {
  className?: string;
  clubs?: ClubDto[];
  tournaments?: components['schemas']['TournamentShortDto'][];
  setIsModalOpen: (isOpen: boolean) => void;
};
export function PlayerClubsAndTournamentsPreview({
  className,
  clubs,
  tournaments,
  setIsModalOpen,
}: Props) {
  const isDesktop = useMediaQuery() === 'desktop';

  if (!clubs || !clubs.length) {
    return null;
  }

  return (
    <Card className={cx(styles.playerClubsAndTournaments, className)}>
      <div className={styles.header}>
        <div className={styles.title}>Мои клубы и турниры</div>

        <SlimArrowButton
          colorPreset="golden"
          direction="right"
          size="20"
          onClick={() => setIsModalOpen(true)}
        />
      </div>

      <div className={styles.content}>
        <PlayerClubs className={styles.clubs} preset={isDesktop ? 'm' : 's'} clubs={clubs} />

        <div className={styles.tournamentsContainer}>
          {tournaments && (
            <PlayerTournaments
              className={styles.tournaments}
              tournaments={tournaments.slice(0, 2)}
              hasMore={false}
              loadMore={() => {}}
              clubs={clubs}
              isUpcoming
            />
          )}

          {tournaments && tournaments.length > 2 && (
            <div className={styles.showMorePrompt} onClick={() => setIsModalOpen(true)}>
              и еще {pluralize(TOURNAMENTS_PLURAL, tournaments.length - 2)}
            </div>
          )}
        </div>
      </div>

      <CapsuleButton
        className={styles.button}
        preset="hollow-white"
        size="16r-32"
        onClick={() => setIsModalOpen(true)}
      >
        <span>Смотреть подробней</span>
        <span className={styles.arrow}>
          <ArrowSlimIcon />
        </span>
      </CapsuleButton>
    </Card>
  );
}
